module.exports = __webpack_public_path__ + "img/HET.67757a76.jpg";